import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c83683e6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c83683e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83683e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mer_admin_DIbX/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c83683e6')) {
      api.createRecord('c83683e6', component.options)
    } else {
      api.reload('c83683e6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c83683e6&scoped=true", function () {
      api.rerender('c83683e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/copyright/index.vue"
export default component.exports